import { FC } from "react";
import { Icon as Iconify } from "@iconify/react";
import "@material/theme/dist/mdc.theme.css";
import { Theme } from "@rmwc/theme";
import { ThemePropT } from "@rmwc/types";
import { Size } from "../../..";

export type IconProps = {
  icon: object;
  size?: Size;
  theme?: ThemePropT;
  color?: string;
  className?: string;
  src?: string;
};

const Svg: FC<IconProps> = ({ icon, size, theme, color, className, src }) => {
  let width = 18;
  let height = 18;

  switch (size) {
    case "xsmall":
      width = 16;
      height = 16;
      break;
    case "small":
      width = 18;
      height = 18;
      break;
    case "medium":
      width = 25;
      height = 25;
      break;
    case "large":
      width = 40;
      height = 40;
      break;
    case "xlarge":
      width = 45;
      height = 45;
  }

  if (src) {
    return <img src={src} height={height} width={width} color={color} className={`${className} custom-image`} alt="" />;
  } else if (icon) {
    return (
      <Theme use={theme ? theme : ["onSurface"]} wrap>
        <Iconify icon={icon} height={height} width={width} color={color} className={className} />
      </Theme>
    );
  }
  return null;
};

export default Svg;
